(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
    Progressive enhancement for the header disclosures. Everything works
    without this: <details> opens and closes natively.
    - Escape closes the open disclosure and returns focus to its summary.
    - A click or focus outside closes it.
    - Opening one desktop sub-menu closes the others.
    - Widening past 64rem closes the mobile menu, releasing its scroll lock.
    - The currency submit button hides until the choice differs from the
      current currency (a change still needs the button: submitting on
      `change` would reload the page on the first arrow key press).
  */
  (function () {
    if (window.gbrHeaderInit) return;
    window.gbrHeaderInit = true;

    var SELECTOR = 'details[data-header-disclosure]';

    function closeAll(except) {
      document.querySelectorAll(SELECTOR + '[open]').forEach(function (d) {
        if (d !== except) d.open = false;
      });
    }

    document.addEventListener(
      'toggle',
      function (event) {
        var d = event.target;
        if (d.matches && d.matches(SELECTOR) && d.open) closeAll(d);
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector(SELECTOR + '[open]');
      if (!open) return;
      open.open = false;
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    });

    function outside(event) {
      document.querySelectorAll(SELECTOR + '[open]').forEach(function (d) {
        if (!d.contains(event.target)) d.open = false;
      });
    }
    document.addEventListener('click', outside);
    document.addEventListener('focusin', outside);

    // The mobile menu is hidden from 64rem (lg:hidden) but stays [open] if
    // the viewport grows while it is open, and critical.css locks page
    // scroll for any open details[scroll-lock]. Close it at the breakpoint.
    var wide = window.matchMedia('(min-width: 64rem)');
    function closeMobileMenu() {
      if (!wide.matches) return;
      document.querySelectorAll('details[data-header-mobile-menu][open]').forEach(function (d) {
        d.open = false;
      });
    }
    if (wide.addEventListener) wide.addEventListener('change', closeMobileMenu);
    else if (wide.addListener) wide.addListener(closeMobileMenu);

    function initCurrency(root) {
      root.querySelectorAll('form.site-currency').forEach(function (form) {
        var select = form.querySelector('[data-currency-select]');
        var submit = form.querySelector('[data-currency-submit]');
        if (!select || !submit) return;
        var initial = select.value;
        var sync = function () {
          submit.hidden = select.value === initial;
        };
        select.addEventListener('change', sync);
        sync();
      });
    }
    initCurrency(document);
    document.addEventListener('shopify:section:load', function (event) {
      initCurrency(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
